import Onboarding4 from "../../components/Onboarding4";

export default function OnboardingPage4() {
    return (
        <Onboarding4 />
    )
};